import { RefObject } from "react"
import { DisabledModeT } from "shared-ts/hooks/useFilter/types/filter.types"

import { useTextDateInput } from "../../../../components/base/input/text/TextDateInput"
import { TextInputProps } from "../../../../components/base/input/text/TextInput"
import { PopoverTextInput } from "../../../../components/base/overlay/Popover"
interface TextDateInputProps extends TextInputProps {
  date: Date | null
  onChangeDate: (date: Date | null) => void
  defaultRefDate: Date
  format?: string
  disabledMode?: DisabledModeT
  ref?: RefObject<HTMLInputElement | null>
}

export const TextDateInput = ({
  ref,
  onChangeDate,
  date,
  format = "MM/dd/yyyy",
  defaultRefDate,
  disabledMode,
  onBlur: onBlurProp,
  ...otherProps
}: TextDateInputProps) => {
  const { inputRef, dateString, onChange, onBlur, onKeyDown } =
    useTextDateInput({
      ref,
      date,
      defaultRefDate,
      format,
      disabledMode,
      onChangeDate,
      onBlurProp,
    })

  return (
    <PopoverTextInput
      ref={inputRef}
      value={dateString}
      onChange={onChange}
      className="w-27 h-8"
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      {...otherProps}
    />
  )
}
